<template>
  <div class="fiat-section">
    <div class="input-container">
      <input
        type="number"
        :value="giveAmount"
        @input="
          $emit('update:give-amount', parseFloat($event.target.value) || 0);
          changeTakeAmount(parseFloat($event.target.value) || 0);
        "
      />
      <div class="desc">{{ giveCurrency.title }}</div>
    </div>

    <div class="fee-list" v-if="calculatedFees && !fiatToCrypto">
      <div class="list">
        <div class="desc title">{{ $t("Fees:") }}</div>
        <div class="item item-fee">
          <div class="text">
            <div class="key">{{ $t("Our fee:") }}</div>
            <div class="value">
              {{
                calculatedFees.commissionFee
                  ? calculatedFees.commissionFee
                  : "Processing..."
              }}
            </div>
          </div>
        </div>
        <div class="item item-total">
          <div class="text">
            <div class="key">{{ $t("Total:") }}</div>
            <div class="value">
              {{
                calculatedFees.total ? calculatedFees.total : "Processing..."
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="radio-buttons">
      <div class="desc">{{ $t(`Choose a currency:`) }}</div>
      <div class="list" v-if="currencies">
        <div class="item" v-for="item in currencies" :key="item.title">
          <label>
            <input
              type="radio"
              :checked="giveCurrency.title === item.title"
              :value="item.title"
              @change="chooseCurrency(item)"
            />
            <div class="desc">{{ item.title }}</div>
          </label>
        </div>
      </div>
    </div>
    <div v-if="$parent.fiatToCrypto" class="radio-list payment-method-list">
      <div class="desc">{{ $t(`Payment method:`) }}</div>

      <div v-if="paymentMethods && paymentMethods.length > 0" class="list">
        <div
          v-for="{ code, image_full, title } in paymentMethods"
          :key="title"
          class="item"
        >
          <label>
            <input
              type="radio"
              :checked="paymentMethod === code"
              @change="$emit('updatePaymentMethod', code)"
              name="paymentMethod"
              :value="code"
            />
            <div class="text">
              <img v-if="image_full" :src="image_full" class="img" />
              <div class="desc">{{ $t(title) }}</div>
            </div>
          </label>
        </div>
      </div>

      <div v-else class="list">
        <div>
          <label>
            <!-- <input type="radio" v-model="paymentMethod" @change="$emit('updatePaymentMethod', code)" name="paymentMethod" :value="code"/> -->
            <div class="text">
              <!-- <img v-if="image_full" :src="image_full" class="img"/> -->
              <div class="desc">{{ this.$parent.paymentMethodError }}</div>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FiatSection",
  props: {
    giveCurrency: {
      type: Object,
    },
    giveAmount: {
      type: Number,
    },
    defaultTakeCurrency: {
      type: Function,
    },
    currencies: {
      type: Object,
    },
    changeTakeAmount: {
      type: Function,
    },
    toggleFiatToCrypto: {
      type: Function,
    },
    paymentMethod: {
      type: String,
      default: "",
    },
    paymentMethods: {
      type: Array,
      default: () => [],
    },
    fiatToCrypto: {
      type: Boolean,
    },
    calculatedFees: {
      type: Object,
    },
  },
  data: function () {
    return {};
  },
  methods: {
    chooseCurrency(event) {
      this.$emit("update:give-currency", event);
      this.defaultTakeCurrency();
    },
  },
};
</script>

<style lang="scss" scoped>
.fiat-section .fee-list {
  margin-top: 16px;

  .key {
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    text-align: left;
    color: #141427;
  }

  .value {
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    color: #282e38;
  }

  .text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .item-fee {
    margin-bottom: 32px;
  }

  .desc.title {
    font-size: 14px;
    line-height: 19px;
    color: #282e38;
    margin-bottom: 16px;
    font-weight: 700;
  }
}
</style>
